import ServicePageLayout from "@/components/ServicePageLayout";
import { CTABand } from "@/components/home/HomeSections";
import { Smartphone, Layers, Code2, Workflow, RefreshCcw, Boxes } from "lucide-react";
import { IMAGES } from "@/data/content";

export default function AppSoftware() {
  return (
    <ServicePageLayout
      eyebrow="App & Software Development"
      title="Apps and software your business can build on"
      intro="Native iOS and Android apps, cross-platform builds and bespoke SaaS engines — designed, engineered and supported by one dedicated UK team."
      image={IMAGES.mobile}
      imageAlt="Mobile app designed and engineered by TechAxis"
      offerings={[
        { icon: Smartphone, title: "iOS & Android apps", desc: "Native-quality apps with smooth offline support, push notifications and app-store launch handled for you." },
        { icon: Layers, title: "Cross-platform builds", desc: "React Native and Flutter delivery that ships both platforms from one codebase without compromise." },
        { icon: Code2, title: "SaaS product engineering", desc: "Multi-tenant SaaS platforms with billing, onboarding and analytics — ready for your first thousand customers." },
        { icon: Workflow, title: "Internal tools & automation", desc: "Replace spreadsheets and email chains with tools that match exactly how your team works." },
        { icon: Boxes, title: "API & microservices", desc: "Well-documented API ecosystems and event-driven services that scale with your roadmap." },
        { icon: RefreshCcw, title: "Legacy modernisation", desc: "Incremental, low-risk migration of ageing systems to modern, supportable architecture." },
      ]}
      process={[
        { title: "Product discovery", desc: "Workshops to define the MVP, user stories and success metrics before a line of code is written." },
        { title: "Prototype & validate", desc: "Clickable prototypes tested with real users to de-risk the build." },
        { title: "Agile delivery", desc: "Two-week sprints, weekly demos and a shared backlog you can inspect any time." },
        { title: "Launch & evolve", desc: "Store submission, monitoring, crash analytics and a post-launch roadmap." },
      ]}
      stack={["React Native", "Flutter", "Swift", "Kotlin", "Python", "FastAPI", "GraphQL", "PostgreSQL", "Redis", "Kubernetes"]}
    >
      <CTABand />
    </ServicePageLayout>
  );
}
